import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/main.scss";
import ContextProvider from "./Context";
import Logger from "./utils/logger";
import { cleanExpiredCache } from "./utils/cache";

if (false && process.env.NODE_ENV !== "development") {
	console.log = (...args) => {
		Logger.log(...args);
	};
	console.warn = (...args) => {
		Logger.warn(...args);
	};
	console.debug = (...args) => {
		Logger.error(...args);
	};
	console.error = (...args) => {
		Logger.error(...args);
	};
}

const render = () => {
	const container = document.createElement("div");
	container.id = "syndicated-root";
	document.body.appendChild(container);

	const root = createRoot(container);
	root.render(
		<React.StrictMode>
			<ContextProvider>
				<App />
			</ContextProvider>
		</React.StrictMode>
	);
};

cleanExpiredCache();
render();
